// Translations
import form from '../sections/form/translations/ar'

// Translation: Password change > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
